<template>
	<div class="options_list">
		<div class="options_Item" v-for="(item,index) in options" :key="index" @click="handleClickOption(item,index)">
			<div :class="['left',manyAnswer.includes(index)?'manyClass':'',youAnswer.length>0&&answer.includes(index)&&!youAnswer.includes(index)?'err_answer':'']">
				
				<span 
				v-show="youAnswer.length==0||(!youAnswer.includes(index)&&!answer.includes(index))||(!youAnswer.includes(index)&&answer.includes(index))"
				>{{aipchOptions[index]}}</span>

				<i class="el-icon-success"
				v-show="youAnswer.length>0&&youAnswer.includes(index)&&answer.includes(index)" 
				style="font-size: 40px;color:#3964E6;"
				></i>
				<i class="el-icon-error"
				v-show="youAnswer.length>0&&youAnswer.includes(index)&&!answer.includes(index)" 
				style="font-size: 40px;color:#F63F33;"
				></i>
				
			</div>
			<div class="right">
				{{item.txt}}
			</div>
		</div>
		<el-button v-if="youAnswer.length==0" type="primary" @click="handManyClick" circle>确定</el-button>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				aipchOptions:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'],
				manyAnswer:[],
			}
		},
		props:{
			options:{
				type:Array,
				default:()=>{
					return []
				}
			},
			answer:{
				type:Array,
				default:()=>{
					return []
				},
			},
			quType:{
				type:[Number,String],
				default:''
			},
			youAnswer:{
				type:Array,
				default:()=>{
					return []
				},
			},
			isClick:{
				type:Boolean,
				default:true
			},
		},
		destroyed() {
			this.clearSearch()
		},
		mounted() {
			console.log(this.youAnswer)
		},
		methods:{
			handleClickOption(item,i){
				if(this.manyAnswer.indexOf(i)<0){
					this.manyAnswer.push(i)
				}else{
					this.manyAnswer.splice(this.manyAnswer.indexOf(i),1)
				}
			},
			handManyClick(){
				console.log(this.isClick)
				if(this.isClick){
					if(this.manyAnswer.length<2){
						uni.$u.toast('多选题，最少选择两项')
						return
					}
					var obj={
						myAnswer:[...(this.manyAnswer.map(v=>v*1).sort(function(a,b){return a-b}))],
						isFlag:this.contrast(this.answer,[...this.manyAnswer]),
						isClick:false
					}
					this.$emit('setManyClick',obj)
					this.manyAnswer = []
				}
				
			},
			contrast(arr1,arr2){
				const newArr1 = JSON.stringify(arr1.map(v=>v*1).sort(function(a,b){return a-b}))
				const newArr2 = JSON.stringify(arr2.map(v=>v*1).sort(function(a,b){return a-b}))
				if(newArr1==newArr2){
					return true
				}else{
					return false
				}
			},
			clearSearch(){
				this.manyAnswer = []
			}
		}
	}
</script>

<style scoped lang="scss">
	.options_list{
		margin-top: 70px;
	}
	.options_Item{
		display: flex;
		margin-bottom: 50px;
		.left{
			width: 60px;
			height: 60px;
			color: #000;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0px 1px 7px 0px rgb(0 0 0 / 10%);
			font-size: 15px;
			box-sizing: border-box;
			line-height: 1;
			margin-right: 33px;
			overflow: hidden;
		}
		.right{
			margin-top: 10px;
			flex: 1;
		}
		.manyClass{
			background: #d8d8d8;
		}
		.err_answer{
			background: #3964E6;
			color: #fff;
		}
	}
</style>
